import { POST } from "../../index";

export const queryTaskReport = (param) => POST("/v1/TaskController/queryTaskReport", param);
export const queryTaskUser = (param) => POST("/v1/TaskController/queryTaskUser", param);
export const subsReports = (param) => POST("/v1/TaskController/subsReports", param);
export const cancelReport = (param) => POST("/v1/TaskController/cancelReport", param);
